import {
  TOOFI_ARTIFACT_INDEX_KEY,
  TOOFI_ARTIFACT_STORAGE_EVENT,
  type ToofiArtifactRecordIndexItem,
} from "@/lib/toofi-artifact-types";

const now = () => Date.now();

const readJson = <T>(key: string): T | null => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

const dispatchArtifactEvent = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(TOOFI_ARTIFACT_STORAGE_EVENT));
};

export const readToofiArtifactIndex = (): ToofiArtifactRecordIndexItem[] => {
  const raw = readJson<ToofiArtifactRecordIndexItem[]>(TOOFI_ARTIFACT_INDEX_KEY);
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((item) => item && typeof item === "object" && typeof item.id === "string")
    .sort((left, right) => {
      if (left.pinned !== right.pinned) return left.pinned ? -1 : 1;
      return right.updatedAt - left.updatedAt;
    });
};

export const writeToofiArtifactIndex = (items: ToofiArtifactRecordIndexItem[]) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(TOOFI_ARTIFACT_INDEX_KEY, JSON.stringify(items));
    dispatchArtifactEvent();
  } catch {
    // best effort local persistence only
  }
};

export const upsertToofiArtifactIndexItem = (item: ToofiArtifactRecordIndexItem) => {
  const current = readToofiArtifactIndex();
  const next = current.filter((entry) => entry.id !== item.id);
  next.unshift({ ...item, updatedAt: item.updatedAt || now() });
  writeToofiArtifactIndex(next);
};

export const removeToofiArtifactIndexItem = (artifactId: string) => {
  writeToofiArtifactIndex(readToofiArtifactIndex().filter((item) => item.id !== artifactId));
};

